var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardSuffix2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 10,
    cy: 70,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 40,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 10,
    cy: 100,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 10,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 40,
    cy: 70,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 40,
    cy: 40,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 40,
    cy: 100,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 70,
    cy: 10,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 70,
    cy: 70,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 70,
    cy: 40,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 70,
    cy: 100,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 100,
    cy: 10,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 100,
    cy: 70,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 100,
    cy: 40,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 100,
    cy: 100,
    r: 8,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSuffix2);
export default __webpack_public_path__ + "static/media/CardSuffix2.25a3bbf525dd377f652e1dd9b4eb3aee.svg";
export { ForwardRef as ReactComponent };